<template>
    <div class="patient-content-wrap">
        <bread-crumb :bread-list="breadList" />

        <div class="list-content">
            <div class="title-wrap">
                <i class="iconfont icon-tongyongbiaotiicon"></i>
                <span class="title-text">内容列表</span>
            </div>
            <div class="search-wrap">
                <div class="option-wrap">
                    <div class="option-item">
                        <span class="label">标题</span>
                        <el-input placeholder="请输入标题"
                                  v-model="selectForm.title"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>

                    <div class="option-item">
                        <span class="label"
                              style="padding-left:20px;">创建人</span>
                        <el-input placeholder="请输入姓名"
                                  v-model="selectForm.uploader"
                                  :style="{width: '240px'}">
                        </el-input>
                    </div>

                    <div class="option-item">
                        <span class="label"
                              style="padding-left:20px;">注册日期</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.createTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>

                    <div class="option-item">
                        <span class="label"
                              style="padding-left:20px;">上线日期</span>
                        <el-date-picker size="small"
                                        clearable
                                        clear-icon="el-icon-error"
                                        v-model="selectForm.addedTime"
                                        type="daterange"
                                        range-separator="-"
                                        start-placeholder="yyyy-mm-dd"
                                        end-placeholder="yyyy-mm-dd"
                                        value-format="yyyy-MM-dd"
                                        :style="{width: '240px'}"
                                        :picker-options="datePickerOptions">
                        </el-date-picker>
                    </div>
                    <div class="select-btn-wrap">
                        <el-button type="primary"
                                   size="small"
                                   @click="searchQuery">查询</el-button>
                        <el-button type="info"
                                   size="small"
                                   plain
                                   @click="resetQuery">重置</el-button>
                    </div>
                </div>
            </div>
            <div class="add-wrap">
                <el-button class="original-btn"
                           @click="handleNewClick">新建原创</el-button>
                <el-button class="original-btn"
                           @click="handleNewHalfClick">新建半原创</el-button>
            </div>

            <div class="table-wrap">
                <el-table :data="dataList"
                          stripe
                          v-loading="loading"
                          style="width: 100%">
                    <el-table-column min-width="50px"
                                     label="序号">
                        <template slot-scope="scope">
                            <span>{{  scope.$index + (page.current - 1) * page.pageSize + 1 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="title"
                                     min-width="120px"
                                     label="标题">
                    </el-table-column>
                    <el-table-column prop="uploader"
                                     min-width="120px"
                                     label="创建人">
                    </el-table-column>
                    <el-table-column min-width="120px"
                                     label="类型">
                        <template slot-scope="{row}">
                            <span v-if="row.contentType === 'HALF_ORIGINAL'">半原创</span>
                            <span v-if="row.contentType === 'ORIGINAL'">原创</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime"
                                     min-width="120px"
                                     label="创建时间">
                    </el-table-column>
                    <el-table-column prop="addedTime"
                                     min-width="120px"
                                     label="上线日期">
                    </el-table-column>
                    <el-table-column label="操作"
                                     width="120px">
                        <template slot-scope="{row}">
                            <span @click="handleClick(row)"
                                  class="link-btn">编辑</span>
                            <span class="link-btn"
                                  @click="hanldeDialogVisible(row.contentId)">删除</span>
                        </template>
                    </el-table-column>
                    <div slot="empty">
                        <table-empty />
                    </div>
                </el-table>
            </div>
            <div class="pagination-wrap">
                <el-pagination background
                               @current-change="handlePageChange"
                               :current-page.sync="page.current"
                               :page-size="page.pageSize"
                               layout="total, prev, pager, next, jumper"
                               :total="page.total">
                </el-pagination>
            </div>
        </div>
        <message-box :dialog-visible="dialogVisible"
                     :id="contentId"
                     warning-text="确认将标题删除？"
                     @handleConfirm="handleConfirm"
                     @handleClose="handleClose" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageBox from '@/components/MessageBox'
import shortcuts from '@/utils/pickerOptions'
import { postContentList, deleteByContentId } from '@/api/patient/content'
export default {
    name: 'patientContentList',
    data () {
        return {
            breadList: [{ label: '内容管理' }, { label: '内容列表' }],
            dataList: [],
            datePickerOptions: {
                shortcuts: shortcuts
            },
            loading: false,
            dialogVisible: false,
            contentId: '',
            selectForm: {
                title: '',
                uploader: '',
                createTime: '',
                addedTime: ''
            },
            page: {
                current: 1,
                total: 1,
                pageSize: 10
            }
        }
    },
    computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    components: {
        MessageBox
    },
    methods: {
        handleClose () {
            this.dialogVisible = false
        },
        hanldeDialogVisible (contentId) {
            this.contentId = contentId
            this.dialogVisible = true
        },
        handleConfirm (contentId) {
            this.loading = true
            this.dialogVisible = false
            this.handleDeleteContent(contentId)
        },
        async handleDeleteContent (contentId) {
            const { state } = await deleteByContentId(contentId)
            if (state === 200) {
                this.$message({
                    message: '删除标题成功',
                    customClass: 'hos-message--success',
                    iconClass: 'el-icon-success',
                    duration: '2000'
                })
                this.query(this.page.current)
            }
        },
        handleClick (row) {
            if (row.contentType === 'HALF_ORIGINAL') {
                this.$router.push({ path: '/patient/content/editSemiOriginal', query: { contentId: row.contentId } })
            }
            if (row.contentType === 'ORIGINAL') {
                this.$router.push({ path: '/patient/content/editOriginal', query: { contentId: row.contentId } })
            }
        },
        searchQuery () {
            this.query(1)
        },
        resetQuery () {
            this.selectForm.title = ''
            this.selectForm.uploader = ''
            this.selectForm.createTime = ''
            this.selectForm.addedTime = ''
            this.query(1)
        },
        handlePageChange (val) {
            this.query(val)
        },
        query (val) {
            this.page.current = val
            this.queryList()
        },
        // 新增原创
        handleNewClick () {
            this.$router.push('/patient/content/addOriginal')
        },
        // 新增半原创
        handleNewHalfClick () {
            this.$router.push('/patient/content/addSemiOriginal')
        },
        // 获取内容列表
        async queryList () {
            // 注册日期
            let createTimeStart = ''
            let createTimeEnd = ''
            if (this.selectForm.createTime) {
                createTimeStart = this.selectForm.createTime[0] + ' 00:00:00'
                createTimeEnd = this.selectForm.createTime[1] + ' 23:59:59'
            }
            // 发布日期
            let addedTimeStart = ''
            let addedTimeEnd = ''
            if (this.selectForm.addedTime) {
                addedTimeStart = this.selectForm.addedTime[0] + ' 00:00:00'
                addedTimeEnd = this.selectForm.addedTime[1] + ' 23:59:59'
            }
            let params = {
                title: this.selectForm.title,
                uploader: this.selectForm.uploader,
                createTimeStart: createTimeStart,
                createTimeEnd: createTimeEnd,
                addedTimeStart: addedTimeStart,
                addedTimeEnd: addedTimeEnd,
                size: this.page.pageSize,
                current: this.page.current
            }
            this.loading = true
            this.dataList = []
            const { results, total } = await postContentList(params)
            this.dataList = results
            this.page.total = total
            this.loading = false
        }
    },
    mounted () {
        this.queryList()
    }
}
</script>

<style lang="scss">
.patient-content-wrap {
    height: 100%;
    .list-content {
        height: calc(100% - 81px);
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        margin: 20px;
        padding: 20px 20px 0 20px;
        background: #fff;
        overflow: auto;
        .title-wrap {
            font-size: 0;
            height: 16px;
            line-height: 16px;
            padding-bottom: 10px;
            border-bottom: 1px solid #ccc;
            .icon-tongyongbiaotiicon {
                color: $color-primary;
                font-size: 16px;
                vertical-align: middle;
            }
            .title-text {
                font-size: 14px;
                color: #333333;
                margin-left: 10px;
                display: inline-block;
                height: 16px;
                line-height: 16px;
                vertical-align: middle;
            }
        }
        .original-btn {
            background: #ffffff;
            border: 1px solid #06aea6;
            border-radius: 3px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #06aea6;
            height: 32px;
            padding: 0 15px;
        }
        .search-wrap {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .option-wrap {
                display: flex;
                flex-wrap: wrap;
                margin: 20px 20px 0 0;
                .option-item {
                    margin-bottom: 20px;
                    .label {
                        padding-right: 10px;
                        font-size: 14px;
                        color: #666;
                    }
                    &:last-child {
                        margin-right: 0;
                    }
                    .el-select {
                        margin-right: 10px;
                        &:last-child {
                            margin-right: 0;
                        }
                    }
                    .el-input {
                        margin-right: 10px;
                        .el-input__inner {
                            height: 32px;
                        }
                    }
                    .el-date-editor {
                        margin-right: 10px;
                    }
                }
                .select-btn-wrap {
                    margin-bottom: 20px;
                    margin-left: 20px;
                    .el-button--small {
                        width: 80px;
                        padding: 8px 15px;
                        font-size: 14px;
                    }
                    .el-button--info.is-plain {
                        background: #f5f5f5;
                        border-color: #cccccc;
                        color: #666;
                    }
                }
            }
        }
        .add-wrap {
            margin-bottom: 20px;
        }

        .table-wrap {
            .link-btn {
                color: $a-link;
                cursor: pointer;
                font-size: 12px;
                display: inline-block;
                height: 14px;
                line-height: 14px;
                border-right: 1px solid $a-link;
                margin-right: 6px;
                padding-right: 6px;
                &:last-child {
                    border-right: none;
                    margin-right: 0;
                    padding-right: 0;
                }
            }
        }
    }
}
</style>
